module.exports = __webpack_public_path__ + "media/images/lig/flatlay-03-aaa41ab428c058ccf60fa7ffa96a7fce.png";